<template>
  <div id="app" >
    
    <router-view></router-view>

  </div>
</template>

<script>

export default {
  name: 'App',
  components: {

  },
  created(){

    // var sUserAgent = navigator.userAgent.toLowerCase();

    // var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    // var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    // var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    // var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    // var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    // var bIsAndroid = sUserAgent.match(/android/i) == "android";
    // var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    // var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    // if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
    //     // alert('当前 移动端')
    //     let screenWidth = window.screen.width;

    //     // 缩放页面
    //     const scale = screenWidth/1380;
    //     document.body.style.zoom = scale;

    // } else {
    //     // alert('当前 PC端')

    // }

  },
  mounted(){

  }
}
</script>

<style>

/* 打印预设缩放比例 */
@media print{
  html{
    zoom: 37%;
  }
}

body {
  margin: 0;
  padding: 0;
}
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  /* font-family: "微软雅黑","宋体"; */
  font-size: 18px;
  font-family:PingFang,Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  
  /* 设置打印背景、颜色生效 */
  -webkit-print-color-adjust: exact;

  background: white;
  /* min-width: 1380px; */
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0; 
  overflow: auto;
}


</style>
